import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'components/ui/select';
import Modal from 'components/shared/Modal';

const AgencySelectionModal = ({ isOpen, onOpenChange, onConfirm, agencies, isDisabled, pilgrimsNumber }) => {
  const [selectedAgency, setSelectedAgencyId] = useState('');
  const agency = agencies.find((a) => a.id === selectedAgency);

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title="Sélectionner une agence"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annuler
          </Button>

          <Button variant="hajj" onClick={() => onConfirm(selectedAgency)} disabled={!selectedAgency || isDisabled}>
            Confirmer
          </Button>
        </div>
      }
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-700">
          Veuillez confirmer que vous souhaitez bien assigner ces <strong>{pilgrimsNumber} pèlerins</strong> à
          l&lsquo;agence sélectionnée. Cette action est définitive et ne pourra pas être annulée. Assurez-vous que
          toutes les informations sont correctes avant de procéder.
        </p>

        <Select value={selectedAgency} onValueChange={setSelectedAgencyId}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Choisir une agence" />
          </SelectTrigger>

          <SelectContent>
            {agencies?.map((agency) => (
              <SelectItem key={agency.id} value={agency.id}>
                {agency.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        {selectedAgency && (
          <div className="bg-emerald-50 rounded-lg p-3 space-y-1">
            <p className="text-xs font-medium text-emerald-900">Agence sélectionnée</p>
            <p className="text-sm font-semibold text-emerald-900">{agency.name}</p>
          </div>
        )}
      </div>
    </Modal>
  );
};

AgencySelectionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  onOpenChange: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  agencies: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      ifu: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default AgencySelectionModal;
